import { render, staticRenderFns } from "./ContainersHistory.vue?vue&type=template&id=fc8b2160&scoped=true&"
import script from "./ContainersHistory.vue?vue&type=script&lang=js&"
export * from "./ContainersHistory.vue?vue&type=script&lang=js&"
import style0 from "./ContainersHistory.vue?vue&type=style&index=0&id=fc8b2160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8b2160",
  null
  
)

export default component.exports